import React from "react";

export const CaseStudyCard = ({ item }) => (
  <div className="group hover-zoom">
    <div className="relative overflow-hidden rounded-lg aspect-[4/3] bg-slate-100">
      <img src={item.image} alt={item.title} className="w-full h-full object-cover" loading="lazy" />
      <span className="absolute top-3 left-3 bg-[#0a2540] text-white text-[10px] font-700 uppercase tracking-wider px-2.5 py-1 rounded">
        Case Study
      </span>
    </div>
    <span className="mt-4 inline-block text-xs font-600 text-slate-400">
      {item.company} &middot; {item.topic}
    </span>
    <h3 className="mt-1 font-display font-700 text-lg text-[#0a2540] leading-snug group-hover:text-[#0a6ed1] transition-colors">
      {item.title}
    </h3>
    <p className="mt-2 text-slate-500 text-[14px] leading-relaxed">{item.excerpt}</p>
  </div>
);
